module.exports = __webpack_public_path__ + "img/472881-1619192659.6fff3180.jpg";